/**
 * Dauern lesen und schreiben -- F5-01.
 *
 * **Eingegeben wird, wie gesprochen wird.** "1:30", "90", "1,5h" meinen
 * dasselbe, und wer eine Zeit erfasst, tippt das, was ihm gerade einfaellt.
 * Ein Feld, das nur Minuten annimmt, erzeugt bei jeder dritten Eingabe eine
 * Fehlermeldung -- und danach rechnet der Erfassende im Kopf, was der Rechner
 * tun sollte.
 *
 * Zum Server geht immer die Minutenzahl: Sie ist die gespeicherte Groesse
 * (docs/03, Abschnitt 6), und die Auslegung der Eingabe gehoert an genau eine
 * Stelle.
 */

/** Liest eine Dauereingabe. `null`, wenn sie sich nicht deuten laesst. */
export function parseDuration(input: string): number | null {
  const text = input.trim().toLowerCase().replace(',', '.');
  if (!text) return null;

  // "1:30" -- Stunden und Minuten
  const clock = /^(\d+):([0-5]?\d)$/.exec(text);
  if (clock) {
    return Number(clock[1]) * 60 + Number(clock[2]);
  }

  // "1.5h" oder "2 h" -- Stunden mit Bruchteil
  const hours = /^(\d+(?:\.\d+)?)\s*(?:h|std\.?|stunden?)$/.exec(text);
  if (hours) {
    return Math.round(Number(hours[1]) * 60);
  }

  // "45m" oder "45 min"
  const minutes = /^(\d+)\s*(?:m|min\.?|minuten?)$/.exec(text);
  if (minutes) {
    return Number(minutes[1]);
  }

  // Nackte Zahl: Minuten. Nicht Stunden -- wer "2" tippt, meint in einem
  // Ticketsystem zwei Minuten und nicht zwei Stunden, und die kleinere
  // Auslegung ist die, die auffaellt.
  if (/^\d+$/.test(text)) {
    return Number(text);
  }

  return null;
}

/** Formt Minuten in "1:30". */
export function formatDuration(minutes: number): string {
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  return `${String(hours)}:${String(rest).padStart(2, '0')}`;
}

/** Formt Minuten in "1,50 h" -- fuer Summen, die zu Zahlen addiert werden. */
export function formatHours(minutes: number): string {
  return `${(minutes / 60).toFixed(2).replace('.', ',')} h`;
}
